import { Component, OnInit } from '@angular/core';

import moment from 'moment';
import * as FileSaver from 'file-saver';

import { PrestadorService } from '../prestador/prestador.service';
import { Prestador } from '../shared/model/prestador.model';
import { RelatorioSearchParameter } from '../shared/model/search/relatorio-search-parameters.model';
import { AtendimentoService } from '../core/atendimento/atendimento.service';
import { Relatorio } from '../shared/model/relatorio.model';
import { AuthService } from '../seguranca/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  templateUrl: './relatorio.component.html',
  styleUrls: ['./relatorio.component.css']
})
export class RelatorioComponent implements OnInit {

  filters: RelatorioSearchParameter;
  listaPrestadores: Prestador[];

  listaRelatorio: Relatorio[];

  isFiltersCollapsed = true;

  constructor(private prestadorService: PrestadorService, private toast: ToastrService,
    private atendimentoService: AtendimentoService, private authService: AuthService) { }

  ngOnInit() {
    this.listaRelatorio = new Array<Relatorio>();

    // Inicializar os filtros
    this.filters = new RelatorioSearchParameter();

    if (this.isVisible()) {

    }

    // Preencher lista de prestadores
    this.getPrestadores();
  }

  /**
   * Método responsável por setar os valores dos filtros de datas.
   * @param customDateSelectionEvent evento com as datas selecionadas no componente.
   */
  setPeriodDateFilter(customDateSelectionEvent: any) {
    this.filters.dataInicio = moment(customDateSelectionEvent[0]).set({ hour: 0, minute: 0, second: 0 }).toDate();
    this.filters.dataFim = moment(customDateSelectionEvent[1]).set({ hour: 23, minute: 59, second: 59 }).toDate();
  }

  // Método responsável por exportar os dados para um arquivo Excel.
  gerarRelatorioSinteticoHCM() {
    console.log(this.filters.prestador);
    this.atendimentoService.gerarRelatorioSinteticoHCM(this.filters).subscribe(
      (dados) => {
        // Instanciar o arquivo.
        const file = new Blob([dados], {
          type: dados.type
        });

        // Exportar o arquivo.
        FileSaver.saveAs(file, 'Relatorio_Sintetico_AMM.xlsx');
      },
      () => this.toast.error('Erro ao processa relatório, tente novamente!')
    );
  }

  gerarRelatorioAnalitico() {
    this.atendimentoService.gerarRelatorioAnalitico(this.filters).subscribe(
      (dados) => {
        // Instanciar o arquivo.
        const file = new Blob([dados], {
          type: dados.type
        });

        // Exportar o arquivo.
        FileSaver.saveAs(file, 'Relatorio_Analitico_AMM.xlsx');
      },
      () => this.toast.error('Erro ao processa relatório, tente novamente!')
    );
  }

  gerarRelatorioADPHCM() {
    this.atendimentoService.gerarRelatorioADP(this.filters).subscribe(
      (dados) => {
        // Instanciar o arquivo.
        const file = new Blob([dados], {
          type: dados.type
        });

        // Exportar o arquivo.
        FileSaver.saveAs(file, 'Relatorio_ADP_AMM.xlsx');
      },
      () => this.toast.error('Erro ao processa relatório, tente novamente!')
    );
  }

  // Método responsável por gerar o relatório com os dados do antendimento
  gerarRelatorio() {
    console.log(this.filters.prestador);
    this.listaRelatorio = new Array<Relatorio>();

    this.atendimentoService.dadosRelatorio(this.filters).subscribe(
      (dados) => {
        // Validar se tem registros no relatório
        if (dados.length > 0) {
          this.isFiltersCollapsed = true;
          dados.forEach(atendimento => {
            const relatorio = new Relatorio();
            relatorio.atendimento = 0; // TODO: Validar esse campo
            relatorio.autorizacao = 0; // TODO: Validar esse campo

            // Validar se existe o prestador
            if (atendimento.usuario.prestador) {
              relatorio.codigoPrestador = atendimento.usuario.prestador.codigo;
              relatorio.nomePrestador = atendimento.usuario.prestador.nome;
            }

            relatorio.contrato = this.setarNumeroContrato(atendimento.estabelecimentoCodigo);
            relatorio.matricula = atendimento.matricula;
            relatorio.codigoBeneficiario = 0; // TODO: Validar esse campo está mock.

            relatorio.nomeBeneficiario = atendimento.beneficiado;
            relatorio.dataInicioAtedimento = atendimento.dataAtendimento;
            relatorio.dataTerminoAtendimento = atendimento.dataAtualizacao;

            // Método para calcular os valores dos atendimentos.
            this.calcularValores(relatorio, atendimento);

            // Se o colaborador foi encaminhado pelo ambulatório não terá nenhum custo para ele.
            relatorio.percentual = atendimento.percentual;

            this.listaRelatorio.push(relatorio);
          });
        } else {
          this.toast.info('Nenhum resultado encontrado');
        }
      },
      () => this.toast.error('Erro ao processa relatório, tente novamente!')
    );
  }

  // Método responsável por limpar os filtros
  limparFiltros(form: any) {
    form.reset();
    this.filters.dataInicio = null;
    this.filters.dataFim = null;
  }

  // Método responsável por formatar o período da data
  getFormatarPeriodoFiltro(): String {
    let format: String = null;

    // se a data inicio e fim estiverem presentes, deve formatar.
    if (this.filters.dataInicio && this.filters.dataFim) {
      format = moment(this.filters.dataInicio).format('DD/MM/YYYY');
      format += '-';
      format += moment(this.filters.dataFim).format('DD/MM/YYYY');
    }

    return format;
  }

  /**
   * Método responsável por calcular os valores dos atendimentos.
   * @param relatorio objeto relatorio com os dados para serem atribuidos
   * @param atendimento dados recebidos da API para calcular os valores.
   */
  private calcularValores(relatorio: Relatorio, atendimento: any) {
    // Calcular o valor dos procedimentos padrões
    atendimento.atendimentos.forEach(procedimento => {
      relatorio.totalServico += procedimento.valorTotal;
    });

    // Calcular os valores dos outros tipos de procedimento (MATERIAL, MEDICAMENTO, TAXA E DIÁRIA)
    atendimento.atendimentosEstratificados.forEach(medicamento => {
      if (medicamento.tipo === 'MEDICAMENTO') {
        relatorio.totalMedicamentos += medicamento.valor;
      } else if (medicamento.tipo === 'MATERIAL') {
        relatorio.totalMaterial += medicamento.valor;
      } else if (medicamento.tipo === 'TAXA') {
        relatorio.totalTaxa += medicamento.valor;
      } else {
        relatorio.totalDiaria += medicamento.valor;
      }
    });

    // Valor total da guia médica
    relatorio.totalGeral = atendimento.valorTotal;
  }

  /**
   * Método responsável para setar o número do contrato através do estabelecimento.
   * @param estabelecimentoCodigo código do estabelecimento para fazer o de-para
   */
  private setarNumeroContrato(estabelecimentoCodigo: number): number {
    let numeroContrato = 0;

    switch (estabelecimentoCodigo) {
      case 901:
        numeroContrato = 4901;
        break;
      case 902:
        numeroContrato = 4902;
        break;
      case 941:
        numeroContrato = 4941;
        break;
      case 904:
        numeroContrato = 4904;
        break;
      case 905:
        numeroContrato = 4905;
        break;
      case 908:
        numeroContrato = 4908;
        break;
      case 910:
        numeroContrato = 4910;
        break;
      case 911:
        numeroContrato = 4911;
        break;
      case 912:
        numeroContrato = 4912;
        break;
      case 900:
        numeroContrato = 4900;
        break;
      case 990:
        numeroContrato = 4990;
        break;
      case 991:
        numeroContrato = 4991;
        break;
      case 914:
        numeroContrato = 4914;
        break;
      case 947:
        numeroContrato = 4947;
        break;
      case 948:
        numeroContrato = 4948;
        break;
      case 881:
        numeroContrato = 4881;
        break;
    }

    return numeroContrato;
  }

  // Método responsável por buscar a lista de prestadores.
  private getPrestadores() {
    this.prestadorService.listarTodosPrestadores().subscribe(
      (dados) => this.listaPrestadores = dados,
      errorResponse => this.toast.error(errorResponse.error.mensagemUsuario)
    );
  }

  isVisible() {
    return this.authService.getLoggedUser().perfil !== 4;
  }
}
